module.exports = __webpack_public_path__ + "img/article10.03fe6582.jpg";